module.exports = __webpack_public_path__ + "static/media/Mary_Edited_Caroussel.3d73a5c4.jpg";